export function isError(arg: unknown): arg is Error {
  if (!(arg instanceof Object)) {
    return false
  }
  if (!("name" in arg) || typeof arg["name"] !== "string") {
    return false
  }
  if (!("message" in arg) || typeof arg["message"] !== "string") {
    return false
  }
  if (("stack" in arg) && typeof arg["stack"] !== "string") {
    return false
  }
  return true
}

export function toError(arg: unknown): Error {
  if (isError(arg)) {
    return arg
  }
  return {
    name: "unknown",
    message: String(arg),
  }
}

